
// import './App.css';
import { Route, Routes } from 'react-router-dom';
import Homepage from 'src/pages/homepage';

import Dashbaord from "src/pages/dashboard";
import Login from './pages/auth/login';
import Page from './pages/page';
import { createCustomTheme } from './theme';
import { ThemeProvider } from '@emotion/react';
import Customer from './pages/customers';
import { SideNavItem } from './layouts/dashboard/side-nav-item';
import Riders from './pages/riders';
import Account from './pages/account';
import Setting from './pages/settings';
import Payment from './pages/payment';
import AllRiders from './pages/rides';
import CompletedRide from './pages/completedRide/completedRide';
import AvailableDistrict from './pages/district/district';




function App() {
  const theme = createCustomTheme();
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Routes>

          <Route exact path="/" element={<Homepage />} />
          <Route path="/auth/login" element={<Login />} />
          <Route path="/dashboard"
            element={Page.getLayout(<Dashbaord />)}
          />
           <Route path="/dashboard/customers" element={Page.getLayout(<Customer />)} />
           <Route path="/dashboard/riders" element={Page.getLayout(<Riders />)} />
           <Route path="/dashboard/account" element={Page.getLayout(<Account />)} />
           <Route path="/dashboard/settings" element={Page.getLayout(<Setting />)} />
           <Route path="/dashboard/payment" element={Page.getLayout(<Payment />)} />
           <Route path="/dashboard/rides" element={Page.getLayout(<AllRiders />)} />
           <Route path="/dashboard/completed-rides" element={Page.getLayout(<CompletedRide />)} />
           <Route path="/dashboard/district" element={Page.getLayout(<AvailableDistrict />)} />
        </Routes>
      </ThemeProvider>

    </div>
  );
}

export default App;
